import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { PDFDocument, rgb } from 'pdf-lib';
import BlankCertificate from '../../img/Impact-Directors-Certificate.png'

import axios from 'axios';
import fontkit from '@pdf-lib/fontkit'
import FontAbhaya from '../../AbhayaLibre-SemiBold.ttf'
import RobotoBold from '../../Roboto-Bold.ttf'
import AbhayaRegular from '../../AbhayaLibre-Regular.ttf'
import GoodVibrations from '../../GoodVibrations Script.ttf'
import PoppinsRegular from '../../Poppins-Regular.ttf'
import AbhayaBold from '../../AbhayaLibre-Bold.ttf'

import QRCode from 'qrcode'
import { useSelector } from 'react-redux';
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { Document, Page, Text, View, StyleSheet,PDFViewer, Image, Font,PDFDownloadLink, } from '@react-pdf/renderer';
import moment from "moment";

const ImpactDirectorCertificate = () => {

    var userEmail;
    var JSToken;
  var accessToken;
  if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  const [currentEventRegisteration, setCurrentEventRegisteration]=useState(null);
  const {eventId,delegateId}= useParams();
  const [qrUriImageFile,setqrUriImageFile]= useState(null);
  const [fontSize,setFontSize]= useState(44);
  const [eventDetails,setEventDetails]= useState(null);
  const [fullNameTop,setFullNameTop]= useState(375);
  const [lowerViewTop,setLowerViewTop]= useState(137);
  const [completeDateTop,setCompleteDateTop]= useState(415.0);
  const [isCertificateReady, setIsCertificateReady] = useState(false);
  const [certificateLoadError, setCertificateLoadError] = useState("");
  const [certificateDetails, setCertificateDetails] = useState({
    signer: "",
    designation: "",
    signatureImage: null,
  });

    Font.register({
        family:'AbhayaLibreSemiBold',
        src:FontAbhaya
      });
    Font.register({
        family:'RobotoBold',
        src:RobotoBold
      });
    Font.register({
        family:'AbhayaRegular',
        src:AbhayaRegular
      });
    Font.register({
        family:'AbhayaBold',
        src:AbhayaBold
      }); Font.register({
        family:'GoodVibrations',
        src:GoodVibrations
      });
      Font.register({
        family:'PoppinsRegular',
        src:PoppinsRegular
      });
      const SIGNATURE_DIMENSIONS = {
        minWidth: 130,
        maxWidth: 140,
        minHeight: 60,
        maxHeight: 80,
        defaultWidth: 140,
        defaultHeight: 62,
      };
      const SIGNATURE_LEFT = 653;
      const SIGNER_BLOCK_WIDTH = 220;
      const SIGNER_BLOCK_CENTER_X =
        SIGNATURE_LEFT + SIGNATURE_DIMENSIONS.defaultWidth / 2;
      const styles = StyleSheet.create({
        page: {
          
        },
        section: {
          margin: 10,
          padding: 10,
          flexGrow: 1
        },viewer: {
          width: 870, 
          height: 690,
        },
        bgimages: {
          height:595,
          width:842,
          position: 'absolute'
        },title:{
            top:15,
            textAlign:'center',
            fontSize:58,
            color:'white',
          fontFamily:'AbhayaLibreSemiBold'
        },participation:{
            top:15,
            textAlign:'center',
            fontSize:21,
            color:'#F3D649',
          fontFamily:'RobotoBold'
        },initialline:{
            letterSpacing:1.5,
            top:210,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },showcase:{
            top:250,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'PoppinsRegular',
          marginHorizontal:144
        },complete:{
            top:250,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },completeDate:{
            top:completeDateTop,
            left:89.5,
            // textAlign:'center',
            fontSize:13,
            color:'#000000',
          fontFamily:'PoppinsRegular'
        },completeLocation:{
            top:250,
            textAlign:'center',
            fontSize:16,
            color:'#000000',
          fontFamily:'AbhayaRegular'
        },fullname:{
            top:fullNameTop,
            textAlign:'center',
            fontSize:fontSize,
            textTransform: "capitalize",
            fontWeight: 'bold',
            color:'#009EDC',
          fontFamily:'AbhayaRegular'
        },headNameRight:{
            top:321,
            textAlign:'center',
            fontSize:16,
            color:'#4c8dcb',
          fontFamily:'AbhayaBold',
          
        },headNameLeft:{
            top:321,
            textAlign:'center',
            fontSize:16,
            color:'#4c8dcb',
          fontFamily:'AbhayaBold',
          marginLeft:18
        },headPositionRight:{
            top:318,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'RobotoBold',
          marginRight:45
          
        },headPositionLeft:{
            top:318,
            textAlign:'center',
            fontSize:12,
            color:'#000000',
          fontFamily:'RobotoBold',
          marginLeft:55
        },lowerView:{
            top:lowerViewTop
        },
        QRImage:{
            top:490,
            left:390,
            position:'absolute',
            width:75},
        signatureImage:{
            top:467,
            left:SIGNATURE_LEFT,
            width:SIGNATURE_DIMENSIONS.defaultWidth,
            height:SIGNATURE_DIMENSIONS.defaultHeight,
            minWidth:SIGNATURE_DIMENSIONS.minWidth,
            maxWidth:SIGNATURE_DIMENSIONS.maxWidth,
            minHeight:SIGNATURE_DIMENSIONS.minHeight,
            maxHeight:SIGNATURE_DIMENSIONS.maxHeight,
            position:'absolute',
            objectFit:'contain'
        },
        signerBlock:{
            top:540,
            left:SIGNER_BLOCK_CENTER_X - SIGNER_BLOCK_WIDTH / 2,
            width:SIGNER_BLOCK_WIDTH,
            alignItems:'center',
            position:'absolute'
        },
        signerName:{
            width:'100%',
            textAlign:'center',
            fontSize:10,
            color:'#009EDC',
            fontFamily:'PoppinsRegular',
            textTransform:'uppercase'
        },
        signerDesignation:{
            width:'100%',
            marginTop:1,
            textAlign:'center',
            fontSize:9,
            color:'#000000',
            fontFamily:'RobotoBold',
            textTransform:'uppercase'
        }
        
      });

        // States
       
        const generateQR = async text => {
            try {
              return await QRCode.toDataURL(text,{
                color: {
                  dark: '#009EDC',  // Blue dots
                  light: '#0000' // Transparent background
                }
              })
              
            } catch (err) {
              console.error(err)
            }
          } 

          const getFirstDefinedValue = (source, keys) => {
            for (let index = 0; index < keys.length; index += 1) {
              const value = source?.[keys[index]];
              if (value !== undefined && value !== null && `${value}`.trim() !== "") {
                return `${value}`.trim();
              }
            }
            return "";
          };

          const blobToDataUri = (blobData) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blobData);
            });

          const fetchSignatureImage = async (signatureFileUrl) => {
            const normalizedSignatureUrl = `${signatureFileUrl || ""}`.trim();
            if (!normalizedSignatureUrl) {
              return null;
            }

            if (normalizedSignatureUrl.startsWith("data:")) {
              return normalizedSignatureUrl;
            }

            try {
              const signatureDownloadUrl =
                normalizedSignatureUrl.startsWith("http://") ||
                normalizedSignatureUrl.startsWith("https://")
                  ? normalizedSignatureUrl
                  : `https://dash.bestdiplomats.org/api/method/frappe.core.doctype.file.file.download_file?file_url=${encodeURIComponent(normalizedSignatureUrl)}`;

              const signatureResponse = await axios.get(signatureDownloadUrl, {
                ...config,
                responseType: "blob",
              });
              return await blobToDataUri(signatureResponse.data);
            } catch (error) {
              console.log(error);
              return null;
            }
          };

          const fetchCertificateDetails = async () => {
            const certificateListResponse = await axios.get(
              `https://dash.bestdiplomats.org/api/resource/Certificates%20Info?filters=[["events","=","${eventId}"]]&order_by=creation desc&limit_page_length=1`,
              config
            );

            const certificateName = certificateListResponse?.data?.data?.[0]?.name;
            if (!certificateName) {
              throw new Error("Certificate information is missing for this event.");
            }

            const certificateResponse = await axios.get(
              `https://dash.bestdiplomats.org/api/resource/Certificates%20Info/${encodeURIComponent(certificateName)}`,
              config
            );
            const certificateData = certificateResponse?.data?.data || {};
            const signer = getFirstDefinedValue(certificateData, [
              "signer",
              "signer_name",
              "sender_name",
              "signed_by",
            ]);
            const designation = getFirstDefinedValue(certificateData, [
              "designation",
              "signer_designation",
              "sender_designation",
            ]);
            const signatureField = getFirstDefinedValue(certificateData, [
              "signature",
              "signer_signature",
              "sender_signature",
            ]);
            const signatureImage = await fetchSignatureImage(signatureField);

            return {
              signer,
              designation,
              signatureImage,
            };
          };
        
          //   Get User Registeration

      useEffect(() => {
        let isMounted = true;

        const fetchCertificateDependencies = async () => {
            try {
              setIsCertificateReady(false);
              setCertificateLoadError("");

              const [registrationResponse, eventResponse, loadedCertificateDetails] = await Promise.all([
                axios.get(
                  `https://dash.bestdiplomats.org/api/method/get-registration?event=${eventId}&delegate=${delegateId}`,
                  config
                ),
                axios.get(
                  "https://dash.bestdiplomats.org/api/resource/Events/" + eventId
                ),
                fetchCertificateDetails(),
              ]);

              const registrationData = registrationResponse?.data?.data;
              const loadedEventDetails = eventResponse?.data?.data;

              if (!registrationData) {
                throw new Error("Registration details are missing.");
              }
              if (!loadedEventDetails) {
                throw new Error("Event details are missing.");
              }

              const qrImage = await generateQR(
                `https://verify.impactdirectors.org/verify/${registrationData.delegate_profile.name}-${eventId}-${registrationData.name}`
              );
              if (!qrImage) {
                throw new Error("QR code could not be generated.");
              }

              if (!isMounted) {
                return;
              }

              setCurrentEventRegisteration(registrationData);
              setEventDetails(loadedEventDetails);
              setCertificateDetails(loadedCertificateDetails);
              setqrUriImageFile(qrImage);

              if ((registrationData.delegate_profile.user.first_name + registrationData.delegate_profile.user.last_name).length > 25) {
                setFontSize(38);
                setFullNameTop(379.2);
                setLowerViewTop(142);
                setCompleteDateTop(421.5);
              } else {
                setFontSize(44);
                setFullNameTop(375);
                setLowerViewTop(137);
                setCompleteDateTop(415.0);
              }

              setIsCertificateReady(true);
            } catch (e) {
              console.log(e);
              if (!isMounted) {
                return;
              }
              setCertificateLoadError(
                e?.message ||
                  "Certificate cannot be generated because required API data is missing."
              );
            }
          };

          fetchCertificateDependencies();

          return () => {
            isMounted = false;
          };
      }, [eventId, delegateId]);

  if (certificateLoadError) {
    return (
      <div>
        <span className="group relative flex w-96 justify-center rounded-md border border-transparent bg-red-600 my-4 py-2 px-4 text-sm font-medium text-white">
          {certificateLoadError}
        </span>
      </div>
    );
  }

  if (!isCertificateReady) {
    return (
      <div>
        <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-red-400 my-4 py-2 px-4 text-sm font-medium text-white">
          Preparing certificate data...
        </span>
      </div>
    );
  }

  return (
    <div>
    <PDFDownloadLink document={ <Document>
        <Page size={[842,595]} >
        <Image src={BlankCertificate} style={styles.bgimages}></Image>
    <Text style={styles.fullname}>{""}{""+(currentEventRegisteration?.delegate_profile.user.first_name.replace(/\n/g, "")?.toLowerCase())+" "+(currentEventRegisteration?.delegate_profile.user.last_name.replace(/\n/g, "")?.toLowerCase())}</Text>
    <View style={styles.lowerView}>
    <Text style={styles.showcase}>In recognition of your visionary thinking, strategic planning and innovative problem solving at Impact Directors {eventDetails?.country}.</Text>
    </View>
    <Text style={styles.completeDate}>{moment(eventDetails?.end_date).format("Do MMMM YYYY")}</Text>
    {certificateDetails?.signatureImage && (
      <Image source={certificateDetails.signatureImage} style={styles.signatureImage}></Image>
    )}
    {(certificateDetails?.signer || certificateDetails?.designation) && (
      <View style={styles.signerBlock}>
        {certificateDetails?.signer && (
          <Text style={styles.signerName}>{certificateDetails.signer}</Text>
        )}
        {certificateDetails?.designation && (
          <Text style={styles.signerDesignation}>{certificateDetails.designation}</Text>
        )}
      </View>
    )}
    <Image source={qrUriImageFile} style={styles.QRImage}></Image>

    </Page>
  </Document>} fileName={`Invitation-${currentEventRegisteration?.delegate_profile.user.full_name}.pdf`}>
  {({ blob, url, loading, error }) =>
        loading ? ( <span className='group relative flex w-64 justify-center rounded-md border border-transparent bg-red-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'>Loading...</span>) : ( <span className='group relative flex w-64 justify-center rounded-md border border-transparent bg-red-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2'>Download PDF</span>)
      }
  </PDFDownloadLink>

<PDFViewer style={styles.viewer}>
    <Document>
    <Page size={[842,595]} >
    <Image src={BlankCertificate} style={styles.bgimages}></Image> 
    <Text style={styles.fullname}>{""}{""+(currentEventRegisteration?.delegate_profile.user.first_name.replace(/\n/g, "")?.toLowerCase())+" "+(currentEventRegisteration?.delegate_profile.user.last_name.replace(/\n/g, "")?.toLowerCase())}</Text>
    <View style={styles.lowerView}>
    <Text style={styles.showcase}>In recognition of your visionary thinking, strategic planning and innovative problem solving at Impact Directors {eventDetails?.country}.</Text>
   
    </View>
    <Text style={styles.completeDate}>{moment(eventDetails?.end_date).format("Do MMMM YYYY")}</Text>
    {certificateDetails?.signatureImage && (
      <Image source={certificateDetails.signatureImage} style={styles.signatureImage}></Image>
    )}
    {(certificateDetails?.signer || certificateDetails?.designation) && (
      <View style={styles.signerBlock}>
        {certificateDetails?.signer && (
          <Text style={styles.signerName}>{certificateDetails.signer}</Text>
        )}
        {certificateDetails?.designation && (
          <Text style={styles.signerDesignation}>{certificateDetails.designation}</Text>
        )}
      </View>
    )}
    <Image source={qrUriImageFile} style={styles.QRImage}></Image>

    </Page>
  </Document>
  </PDFViewer>
    </div>
  )
}

export default ImpactDirectorCertificate
